import React, { useState } from 'react';
import { PanelResizeHandle } from 'react-resizable-panels';
import { IconCaretDownFilled, IconCaretLeftFilled, IconCaretRightFilled, IconCaretUpFilled } from '@tabler/icons-react';

const ResizablePanelVerticalHandle = () => {
  const [isHovered, setIsHovered] = useState(false);

  const onHover = () => {
    setIsHovered(prev => !prev);
  };

  return (
    <PanelResizeHandle>
      <div
        style={{
          display: 'flex',
          cursor: 'ew-resize',
        }}
      >
        <IconCaretLeftFilled size="15" color="#ddd" />
        <div
          style={{
            width: '1px',
            height: '100vh',
            backgroundColor: !isHovered ? '#ddd' : 'blue'
          }}
          onMouseEnter={onHover}
          onMouseLeave={onHover}
        />
        <IconCaretRightFilled size="15" color="#ddd" />
      </div>
    </PanelResizeHandle>
  );
};

export const ResizablePanelHorizontalHandle = () => {
  const [isHovered, setIsHovered] = useState(false);

  const onHover = () => {
    setIsHovered(prev => !prev);
  };

  return (
    <PanelResizeHandle>
      <div
        style={{
          display: 'flex',
          cursor: 'ew-resize',
        }}
      >        <div
          style={{
            width: '100vw',
            height: '1px',
            backgroundColor: !isHovered ? '#ddd' : 'blue'
          }}
          onMouseEnter={onHover}
          onMouseLeave={onHover}
        />
      </div>
    </PanelResizeHandle>
  );
};


export default ResizablePanelVerticalHandle;
